import { Form, Formik } from 'formik';
import React from 'react';
import { initialValues, onSubmit, validationSchema } from './changePasswordFormikCodes';
import GetField from '../../components/GetField';
import KeyIcon from '@mui/icons-material/Key';

const ChangePassword = () => {
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, actions) => onSubmit(values, actions)}
            validationSchema={validationSchema}
            validateOnMount
        >
            {(formik) => {
                return (
                    <Form className="flex flex-col items-center
                    max-w-screen-sm mx-auto px-1 py-2">
                        <div className="w-full text-center">
                            <KeyIcon sx={{
                                fontSize: "2.5rem"
                            }} />
                        </div>
                        <h1 className="w-full text-center mb-6 text-lg">
                            تغییر رمز عبور
                        </h1>
                        <div className="mb-5 w-full md:w-3/5 max-w-screen-sm">
                            <GetField
                                control="password"
                                name="old_password"
                                placeholder="رمز عبور فعلی"
                                formik={formik}
                            />
                        </div>
                        <div className="mb-5 w-full md:w-3/5 max-w-screen-sm">
                            <GetField
                                control="password"
                                name="new_password"
                                placeholder="رمز عبور جدید"
                                formik={formik}
                            />
                        </div>
                        <div className="mb-5 w-full md:w-3/5 max-w-screen-sm">
                            <GetField
                                control="password"
                                name="confirm_password"
                                placeholder="تکرار رمز عبور جدید"
                                formik={formik}
                            />
                        </div>
                        <div className="w-full text-center mt-4">
                            <GetField
                                control="submitbutton"
                                disabledButton={true}
                                formik={formik}
                                text="تغییر رمز عبور"
                            />
                        </div>
                    </Form>
                );
            }}
        </Formik>
    );
}

export default ChangePassword;
